import type { createEventHandler } from '@wix/tpa-settings';

export enum SettingsTab {
  Main = 'main',
  Texts = 'texts',
  Layout = 'layout',
  Design = 'design',
  Support = 'support',
}

export enum DesignSubTab {
  BackgroundsBorders = 'backgroundsBorders',
  Buttons = 'buttons',
  Dividers = 'dividers',
  Inputs = 'inputs',
  Texts = 'texts',
  DatePicker = 'datePicker',
}

export enum SettingsEvent {
  TabChanged = 'tabChanged',
  SubTabChanged = 'subTabChanged',
}

export type SettingsEventHandler = ReturnType<typeof createEventHandler>;
